module.exports = __webpack_public_path__ + "static/media/status-canceled.2f73f449.svg";